import Jpaper from '@atoms/JPaper';
import { IconSize } from '@constants';

import { PlayIcon } from '@heroicons/react/24/solid';
import { Stack, Typography, useTheme } from '@mui/material';
import {
  GrayDotStyeld,
  IconBoxStyled,
  JPaperStyled,
  RedDotStyeld,
} from './notification-card.styled';
import moment from 'moment';
import GetNotificationsDto from '../../../models/get-notifications.dto';
import NotificationStatus from '../../../models/notification-status.enum';
import { useMakeOneAsRead } from '../../../mutations/notificationMutations';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Paths from '@/routes/paths';
import { useQueryClient } from '@tanstack/react-query';

interface NotificationCardProps {
  notification: GetNotificationsDto;
}

const NotificationCard: React.FC<NotificationCardProps> = ({
  notification,
}) => {
  const { title, body, createdAt, status, id, data } = notification;
  const { mutate, isSuccess } = useMakeOneAsRead();
  const [localStatus, setLocalStatus] = useState<NotificationStatus>(status);
  const navigate = useNavigate();
  const theme = useTheme();
  const queryClient = useQueryClient();
  const markAsRead = useCallback(
    (notificationId: string) => {
      mutate({ notificationId });
    },
    [mutate],
  );

  useEffect(() => {
    if (!isSuccess) return;
    navigate(Paths.CvVideoDetails.replace(':id', data?.cvVideoId));
    setLocalStatus(
      status === NotificationStatus.UNREAD
        ? NotificationStatus.READ
        : NotificationStatus.UNREAD,
    );
  }, [isSuccess]);

  useEffect(() => {
    if (!isSuccess) return;
    queryClient.invalidateQueries(['notifications']);
  }, [isSuccess]);
  return (
    <JPaperStyled>
      <Jpaper onClick={() => markAsRead(id)}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" alignItems="center" gap={2}>
            {localStatus === NotificationStatus.UNREAD && <RedDotStyeld />}
            {localStatus === NotificationStatus.READ && <GrayDotStyeld />}
            <IconBoxStyled>
              <PlayIcon color={theme.palette.white.main} height={IconSize.md} />
            </IconBoxStyled>
            <div>
              <Typography variant="h4">{title}</Typography>
              <Typography variant="caption">{body}</Typography>
            </div>
          </Stack>
          <Typography variant="caption">
            {moment(createdAt).format('DD MMM')}
          </Typography>
        </Stack>
      </Jpaper>
    </JPaperStyled>
  );
};

export default NotificationCard;
